import useSWR from 'swr'
import axios from 'axios'
import { useLocale } from 'hooks'

export const useCarouselData = (
  section: CarouselSection,
  currency: string,
  locale: string,
  delivery_location: string,
  productId?: string
) => {
  const { localiseUrl } = useLocale()

  const params =
    section === 'recently_viewed' ? '&excluded_product_id=' : '&product_id='

  const { data, isLoading } = useSWR(
    `/api/carousels/${section}?currency=${currency}&locale=${locale}&delivery_location=${delivery_location}${
      productId ? params + productId : ''
    }`,
    (url: string) =>
      axios
        .get(localiseUrl(url, { localeAsParam: true }))
        .then((res) => res.data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  return {
    products: data,
    isLoading
  }
}

export type CarouselSection =
  | 'related_products'
  | 'recently_viewed'
  | 'trending_products'
  | 'new_arrivals'
  | 'price_drops'
